"use client";

import { useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";

export default function CompaniesVideo() {
  const [videoClicked, setVideoClicked] = useState(false);

  return (
    <section className="relative my-20 w-full overflow-x-hidden px-6 md:my-30 lg:my-40">
      <div className="relative z-10 mx-auto flex flex-col items-center justify-around gap-6">
        <div className="flex w-full flex-col gap-6 font-bold md:items-center lg:justify-center">
          <div className="flex w-full justify-center">
            <div className="relative aspect-video w-full overflow-hidden rounded-2xl lg:max-w-225">
              <div
                className={cn(
                  "before:bg-primary/20 relative h-full w-full overflow-hidden before:absolute before:inset-0 before:top-0 before:z-10 before:mix-blend-color",
                  {
                    hidden: videoClicked,
                  },
                )}
              >
                <div
                  className="absolute top-1/2 left-1/2 z-10 size-25 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
                  onClick={() => setVideoClicked(true)}
                >
                  <Image src="/icons/play-btn.svg" alt="play button" fill />
                </div>
                <Image
                  src="/video-placeholder-2.webp"
                  alt="video placeholder"
                  className="h-full w-full object-cover"
                  fill
                  sizes="(max-width: 460px) 100vw, (max-width: 1024px) 100vw, 80vw"
                  loading="lazy"
                />
              </div>
              <div className="w-[calc(100vw - 48px)] aspect-video lg:w-screen lg:max-w-225">
                {videoClicked && (
                  <video
                    src="https://res.cloudinary.com/dpywcbkau/video/upload/q_auto/v1754490062/Alex_Interview_qpz6gj.mp4"
                    controls
                    className="h-full w-full object-cover"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute inset-0 z-1 hidden lg:block">
        <Image
          src="/shapes/group-44.svg"
          alt="camera illustration"
          width={90}
          height={90}
          className="absolute top-20 left-1/2 -translate-x-150 -translate-y-1/2"
          loading="lazy"
        />
        <Image
          src="/shapes/group-50.svg"
          alt="camera illustration"
          width={70}
          height={70}
          className="absolute bottom-0 left-32 -translate-x-1/2 -translate-y-1/2"
          loading="lazy"
        />
        <Image
          src="/shapes/group-42.svg"
          alt="camera illustration"
          width={120}
          height={120}
          className="absolute top-24 right-0 translate-x-1/2 -translate-y-1/2"
          loading="lazy"
        />
        <Image
          src="/shapes/mem_stripe_circle2.svg"
          alt="camera illustration"
          width={60}
          height={60}
          className="absolute bottom-6 left-1/2 translate-x-130 -translate-y-1/2"
          loading="lazy"
        />
      </div>
    </section>
  );
}
